import React from 'react';
import Header from '../../components/header';
import HomeBody from './body';
import Footer from '../../components/footer';

function Home() {
    return (
        <div>
            <Header></Header>
            <HomeBody></HomeBody>
            <Footer></Footer>
        </div>
    );
}

export default Home;